module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"alertSettings":"アラート設定","addAlert":"アラート追加","alertID":"アラートID","alertName":"アラート名","stores":"店舗","floor":"フロア数","pos":"レジ番号","message":"メッセージ","status":"ステータス\\t","actions":"編集","confirmDelete":"確認","promptDelete":"選択されたアラートを削除してもよろしいでしょうか？","promptClone":"アラートを複製しますか？","successMessage":"アラートが正常に保存しました。","deleteMessage":"アラートが正常に削除しました。","updateMessage":"アラートが正常に保存しました。"}}')
  delete Component.options._Ctor
}
